"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var format_1 = __importDefault(require("date-fns/format"));

var react_1 = __importDefault(require("react"));

var react_day_picker_1 = __importDefault(require("react-day-picker"));

var Button_1 = __importStar(require("../Button"));

var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));

var DatePickerConfirm =
/** @class */
function (_super) {
  __extends(DatePickerConfirm, _super);

  function DatePickerConfirm(props) {
    var _this = _super.call(this, props) || this;

    _this.onDayClick = function (date) {
      _this.setState({
        value: date
      });
    };

    _this.resetValue = function () {
      if (_this.props.onChange) {
        _this.setState({
          value: undefined
        });

        _this.props.onChange('');
      }
    };

    _this.selectValue = function () {
      if (_this.props.onChange && _this.state.value) {
        _this.props.onChange(format_1.default(_this.state.value, 'yyyy-MM-dd'), _this.state.value);
      }
    };

    _this.footerElement = function () {
      var textResetFilters = LocaleProvider_1.default.locs.datatable.filters.resetFilter;
      var textAccept = LocaleProvider_1.default.locs.datatable.filters.confirm;
      return react_1.default.createElement("div", {
        className: 'DayPicker-Footer-Custom'
      }, react_1.default.createElement("a", {
        href: "javascript:void(0);",
        onClick: _this.resetValue
      }, textResetFilters), react_1.default.createElement(Button_1.default, {
        variant: Button_1.ButtonVariant.Primary,
        onClick: _this.selectValue
      }, textAccept));
    };

    _this.state = {
      value: props.value
    };
    return _this;
  }

  DatePickerConfirm.prototype.componentDidUpdate = function (prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value
      });
    }
  };

  DatePickerConfirm.prototype.render = function () {
    var localization = __assign({}, LocaleProvider_1.default.locs.date_picker.strings);

    return react_1.default.createElement(react_day_picker_1.default, __assign({
      month: this.state.value,
      showOutsideDays: true,
      onDayClick: this.onDayClick,
      selectedDays: this.state.value,
      footerElement: this.footerElement()
    }, localization));
  };

  return DatePickerConfirm;
}(react_1.default.Component);

exports.default = DatePickerConfirm;